import moment, { duration } from 'moment';

import { parsePhoneNumberFromString } from 'libphonenumber-js';
import Timezones from '@/config/timezones';
import { Service } from '@/features/services';
import { formatValue } from 'react-currency-input-field';
import { WeightPriceConfiguration } from '@/features/services/components/PetWeightConfig';
import {
  PetWeight,
  PetWeightConfiguration,
  SizeConfiguration,
} from '@/features/payment/api/petWeights';
import { has } from 'lodash';
import { Console } from 'console';
import { Pets } from '@/features/customers';
import { Room } from '@/features/rooms';

import { Event } from '@/features/events';
import { DayValue } from 'react-modern-calendar-datepicker';
import { ALLOWED_PHONE_COUNTRIES } from '@/config';
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const Utils = {
  DEFAULT_PET_SIZE: 's',
  DEFAULT_PET_SIZE_RANKINGS: ['s', 'm', 'l', 'xl', 'xxl', 'xs'],
  ACCOMODATION_TYPES: {
    DAY_CARE: 'daycare',
    BOARDING: 'boarding',
    GROOMING: 'grooming',
  },
  EVENT_STATUS: {
    REQUESTED: 'requested',
    ACCEPTED: 'accepted',
    CHECKED_IN: 'check-in',
    COMPLETED: 'completed',
    REJECTED: 'rejected',
  },
  INPUT_ELEMENTS: [
    {
      label: 'Small Text Field',
      key: 'textinput',
    },
    {
      label: 'Large Text Field',
      key: 'textarea',
    },
    {
      label: 'Drop Down Select Field',
      key: 'select',
      options: true,
    },
    {
      label: 'Date Field',
      key: 'datepicker',
    },
    {
      label: 'Radio Select Field',
      key: 'radio',
      options: true,
    },
    {
      label: 'Checkbox Select Field',
      key: 'checkbox',
      options: true,
    },
  ],
  VACCINE_TYPES: [
    {
      label: 'Rabbies',
      value: 'rabies',
    },
    {
      label: 'Dhlpp',
      value: 'dhlpp',
    },
    {
      label: 'Canine',
      value: 'canine',
    },
    {
      label: 'Bordetella',
      value: 'bordetella',
    },
  ],
  BREED_UNSPECIFIED: 'Unspecified',
  isValidEmail: (email: string) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!re.test(email)) {
      return false;
    }
    return true;
  },
  getAMPMtime: (hour?: any) => {
    return moment(hour, ['HH:mm:ss']).format('hh:mmA');
  },

  getUpdatedTime: (hour?: any, updatedMinute?: any) => {
    const dt = new Date(hour);
    dt.setMinutes(dt.getMinutes() + updatedMinute);
    return moment(dt, ['HH:mm:ss']).format('hh:mmA');
  },
  getAMPMtime1: (hour?: any) => {
    return moment(hour, ['HH:mm:ss']).format('hh:mm');
  },
  getAMPMtime2: (hour?: any) => {
    return moment(hour, ['HH:mm:ss']).format('A');
  },
  getAMPMtimeWithoutFormat: (hour?: any, timezone?: string) => {
    if (timezone) return moment(hour).tz(timezone).format('hh:mmA');

    return moment(hour).format('hh:mmA');
  },
  getOnlyDate: (hour?: any, format = 'dddd MMM DD, yyyy') => {
    return moment(hour).format(format);
  },
  getDay: (no?: number) => {
    let day = '';
    switch (no) {
      case 1: {
        day = 'Sunday';
        break;
      }
      case 2: {
        day = 'Monday';
        break;
      }
      case 3: {
        day = 'Tuesday';
        break;
      }
      case 4: {
        day = 'Wednesday';
        break;
      }
      case 5: {
        day = 'Thursday';
        break;
      }
      case 6: {
        day = 'Friday';
        break;
      }
      case 7: {
        day = 'Saturday';
        break;
      }
    }
    return day;
  },
  padNumber: (num: number) => {
    if (num.toString().length > 1) return num;
    return `0${num}`;
  },
  getDuration: (duration?: number | null) => {
    if (!duration) {
      duration = 0;
    }
    const minutes = duration % 60;
    const hours = Math.abs(duration - minutes) / 60;
    const parts = [];

    if (hours) parts.push(`${hours} hr`);
    if (!hours || minutes) parts.push(`${minutes} min`);

    return parts.join(' ');
  },
  formatDateString(inputDateStr: string) {
    const inputString = inputDateStr;
    const words = inputString.split(' ');
    words.shift();
    const resultString = words.join(' ');
    return resultString;
  },
  formatDateStringTz(inputDate: any, timezone?: string, dateFormat = 'MMM DD, yyyy') {
    if (timezone) return moment(inputDate).tz(timezone).format(dateFormat);

    return moment(inputDate).format(dateFormat);
  },
  getTzAbbr(timezone?: string) {
    if (!timezone) return moment.tz().zoneAbbr();

    return Timezones[timezone] ? Timezones[timezone].abbr : '';
  },
  getDurationDiff: (start: any, end: any) => {
    const duration = moment(end).diff(start, 'minute');

    return Utils.getDuration(duration);
  },
  getDurationDiffNumber: (start: any, end: any) => {
    return moment(end).diff(start, 'minute');
  },

  timeAgo(inputDateStr: string): string {
    const now = new Date();
    const past = new Date(inputDateStr);
    const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000);

    const dayInSeconds = 86400;
    const diffInDays = Math.floor(diffInSeconds / dayInSeconds);

    // If the difference is more than 1 day, return the exact date
    if (diffInDays > 1) {
      return past.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    }

    const units = [
      { name: 'year', seconds: 31536000 },
      { name: 'month', seconds: 2592000 },
      { name: 'week', seconds: 604800 },
      { name: 'day', seconds: dayInSeconds },
      { name: 'hour', seconds: 3600 },
      { name: 'minute', seconds: 60 },
      { name: 'second', seconds: 1 },
    ];

    for (const unit of units) {
      const interval = Math.floor(diffInSeconds / unit.seconds);
      if (interval >= 1) {
        return interval === 1 ? `1 ${unit.name} ago` : `${interval} ${unit.name}s ago`;
      }
    }

    return 'just now';
  },

  formatDate(inputDateStr: Date): string {
    const inputDate = new Date(inputDateStr);
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const day = inputDate.getDate();
    const month = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const formattedDate = `${day} ${monthNames[month]} ${year}`;
    return formattedDate;
  },
  formatOnlyDay(inputDateStr: string) {
    const inputDate = new Date(inputDateStr);
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const day = inputDate.getDate();
    const month = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const formattedDate = `${monthNames[month]} ${day},`;
    return formattedDate;
  },
  formatDateToString: (inputDateStr: string) => {
    const inputDate = new Date(inputDateStr);
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const day = inputDate.getDate();
    const month = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const formattedDate = `${day} ${monthNames[month]} ${year}`;
    return formattedDate;
  },

  formatDateWithoutNewDate: (dateStr: string) => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const [year, month, day] = dateStr.split('-');

    const formattedDate = `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;

    return formattedDate;
  },
  convertTimestampToTimeFormat: (timestamp: string) => {
    const inputDate = new Date(timestamp);

    const hours = inputDate.getHours();
    const minutes = inputDate.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = String(minutes).padStart(2, '0');

    const timeFormat = `${formattedHours}:${formattedMinutes} ${ampm}`;

    return timeFormat;
  },

  formatPhoneNumber: (input?: string) => {
    if (!input) {
      return input;
    }
    const parsedPhoneNumber = parsePhoneNumberFromString(`+${input}`);
    if (parsedPhoneNumber && parsedPhoneNumber.countryCallingCode) {
      const countryCode = parsedPhoneNumber.countryCallingCode;
      const nationalNumber = parsedPhoneNumber.nationalNumber;
      const numericString = nationalNumber.replace(/\D/g, '');
      const areaCode = numericString.substring(0, 3);
      const localNumber = numericString.substring(3);
      const formattedNumber = `+${countryCode} (${areaCode}) ${localNumber.substring(
        0,
        3
      )}-${localNumber.substring(3)}`;

      return formattedNumber;
    } else {
      return input;
    }
  },
  minutesToDhm: (minutes: number) => {
    const h = Math.floor(minutes / 60);
    const m = Math.floor(minutes % 60);
    const hDisplay = h > 0 ? h + (h == 1 ? ' hour ' : ' hours ') : '';
    const mDisplay = m > 0 ? m + (m == 1 ? ' min ' : ' mins ') : '';
    return hDisplay + mDisplay;
  },
  getFormattedPrice: (amount: number | string) => {
    if (amount == 0) {
      return 'USD 0';
    }
    let planPrice = amount ? amount.toString() : '';
    planPrice =
      planPrice.substring(0, planPrice.length - 2) +
      '.' +
      planPrice.substring(planPrice.length - 2);

    return formatter.format(parseFloat(planPrice));
  },
  getPriceFromService: (service: any, petSize?: string) => {
    let price = 0;
    if (!service) {
      price = 0;
    } else {
      price = parseFloat(service.price);
      if (service.petSizePricing) {
        if (petSize && service.petSizePricing[petSize]) {
          price = parseFloat(service.petSizePricing[petSize].price);
        } else {
          for (let i = 0; i < Utils.DEFAULT_PET_SIZE_RANKINGS.length; i++) {
            const defaultSize = Utils.DEFAULT_PET_SIZE_RANKINGS[i];

            if (!service.petSizePricing[defaultSize]) continue;

            const defaultPrice = parseFloat(service.petSizePricing[defaultSize].price);
            if (defaultPrice > 0) {
              price = defaultPrice;
              break;
            }
          }
        }
      }
    }
    return price;
  },
  getPriceFromServiceAndPets: (service: any, pets: Pets[]) => {
    let price = 0;
    if (!service) {
      price = 0;
    } else {
      if (service.petSizePricing) {
        if (pets.length) {
          pets?.forEach((pet: Pets) => {
            if (pet.petSize && service.petSizePricing[pet.petSize]) {
              price = price + parseFloat(service.petSizePricing[pet.petSize].price);
            } else {
              for (let i = 0; i < Utils.DEFAULT_PET_SIZE_RANKINGS.length; i++) {
                const defaultSize = Utils.DEFAULT_PET_SIZE_RANKINGS[i];

                if (!service.petSizePricing[defaultSize]) continue;

                const defaultPrice = parseFloat(service.petSizePricing[defaultSize].price);
                if (defaultPrice > 0) {
                  price = price + defaultPrice;
                  break;
                }
              }
            }
          });
        } else if (service.petSizePricing[Utils.DEFAULT_PET_SIZE]) {
          price = price + parseFloat(service.petSizePricing[Utils.DEFAULT_PET_SIZE].price);
        }
      } else {
        price = parseFloat(service.price);
      }
    }
    return price;
  },
  getDurationFromServiceAndPets: (service: any, pets?: Pets[]) => {
    let duration = 0;
    if (!service) {
      duration = 0;
    } else {
      if (service.petSizePricing) {
        pets?.forEach((pet: Pets) => {
          if (pet.petSize && service.petSizePricing[pet.petSize]) {
            duration = duration + service.petSizePricing[pet.petSize].duration;
          } else {
            duration = duration + service.petSizePricing[Utils.DEFAULT_PET_SIZE].duration;
          }
        });
      } else {
        duration = service.duration;
      }
    }
    return duration;
  },
  getDurationFromService: (service: any, petSize?: string) => {
    let duration = 0;
    if (!service) {
      duration = 0;
    } else {
      duration = service.duration;
      if (service.petSizePricing) {
        if (petSize && service.petSizePricing[petSize]) {
          duration = service.petSizePricing[petSize].duration;
        } else {
          for (let i = 0; i < Utils.DEFAULT_PET_SIZE_RANKINGS.length; i++) {
            const defaultSize = Utils.DEFAULT_PET_SIZE_RANKINGS[i];

            if (!service.petSizePricing[defaultSize]) continue;

            const defaultPrice = parseFloat(service.petSizePricing[defaultSize].price);
            if (defaultPrice > 0) {
              duration = service.petSizePricing[defaultSize].duration;
              break;
            }
          }
        }
      }
    }
    return duration;
  },
  getRandomColor: () => {
    const randHex = () => {
      return (Math.floor(Math.random() * 56) + 200).toString(16);
    };
    const rand = '#' + randHex() + '' + randHex() + '' + randHex();
    return rand;
  },
  getDefaultPetPrize: () => {
    return {
      xs: { price: 0, duration: 0 },
      s: { price: 0, duration: 0 },
      m: { price: 0, duration: 0 },
      l: { price: 0, duration: 0 },
      xl: { price: 0, duration: 0 },
      xxl: { price: 0, duration: 0 },
    };
  },
  getDefaultPriceFromService: (service: Service | any, currency?: any) => {
    let servicePrice: any = 0;
    if (!service.petSizePricing) {
      servicePrice = service.price;
    } else {
      for (let i = 0; i < Utils.DEFAULT_PET_SIZE_RANKINGS.length; i++) {
        const defaultSize: string = Utils.DEFAULT_PET_SIZE_RANKINGS[i];

        if (!service.petSizePricing[defaultSize]) continue;

        const defaultPrice = parseFloat(service.petSizePricing[defaultSize].price);
        if (defaultPrice > 0) {
          servicePrice = defaultPrice;
          break;
        }
      }
    }
    return currency + Utils.formatAmount(servicePrice);
  },
  getPetSizeValue: (petsizes: PetWeightConfiguration, petSize: string) => {
    const petWeight = petsizes && petsizes[petSize as keyof typeof petsizes];
    return petWeight ? petWeight?.description : '';
  },
  fromServerTz: (
    date?: any,
    serverTimezone?: string,
    format = 'YYYY-MM-DDTHH:mm:ss',
    startofDay = false
  ) => {
    if (startofDay) {
      return new Date(
        moment(date)
          .startOf('day')
          .tz(serverTimezone as string)
          .format(format)
      );
    } else {
      return new Date(
        moment(date)
          .tz(serverTimezone as string)
          .format(format)
      );
    }
  },
  toServerTz: (date?: any, serverTimezone?: string) => {
    return moment.tz(moment(date).format('YYYY-MM-DDTHH:mm:ss'), serverTimezone as string).toDate();
  },
  fromServerTz1: (date?: any, serverTimezone?: string, format = 'YYYY-MM-DDTHH:mm:ss') => {
    return moment(date).tz(serverTimezone as string);
  },

  toServerTzForMaps: (date?: any, serverTimezone?: string) => {
    return moment.tz(moment(date).format('YYYY-MM-DDTHH:mm:ss'), serverTimezone as string);
  },

  onlyDateToServerTz(inputDate: any, timezone?: string, dateFormat = 'DD MMM YYYY') {
    if (timezone) return moment(inputDate).tz(timezone).format(dateFormat);

    return moment(inputDate).format(dateFormat);
  },
  getDefaultDurationFromService: (service: Service | any) => {
    let duration: any = 0;
    if (!service.petSizePricing) {
      duration = service.duration;
    } else {
      for (let i = 0; i < Utils.DEFAULT_PET_SIZE_RANKINGS.length; i++) {
        const defaultSize: keyof typeof service.petSizePricing = Utils.DEFAULT_PET_SIZE_RANKINGS[i];

        if (!service.petSizePricing[defaultSize]) continue;

        const defaultPrice = parseFloat(service.petSizePricing[defaultSize].price) || 0;

        if (defaultPrice > 0) {
          duration = service.petSizePricing[defaultSize].duration;
          break;
        }
      }
    }
    return Utils.getDuration(duration);
  },
  getAddonsPrice: (selectedAddonServices: Service[]) => {
    let total = 0;
    if (selectedAddonServices && selectedAddonServices?.length > 0) {
      selectedAddonServices.forEach((sas: any) => {
        total = total + parseFloat(sas.price);
      });
    }
    return total;
  },
  roundDecimal: (number: any) => {
    if (isNaN(number)) {
      return 0;
    }
    return 343434.34343434;
    //return number ? number.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] : number;
  },
  getRoomPrice: (room: Room, duration: number, totalPet: number) => {
    if (totalPet > 1) {
      const priceForSinglePet = room.perHourPrice * (duration / 60);
      const priceForAddittionalPet = room.extraPerHourPrice * (duration / 60) * (totalPet - 1);
      return priceForSinglePet + priceForAddittionalPet;
    } else {
      const hours = room.perHourPrice * (duration / 60) * totalPet;
      return hours;
    }
  },
  getServiceAlone: (list?: Service[], addons = false) => {
    return list && list.length > 0
      ? list.filter((service: Service) => service.isAddonService == addons)
      : [];
  },
  getCalculatedDays: (start: any, end: any) => {
    const startArray = start.split('/');
    const endArray = end.split('/');

    const startObj: any = new Date(startArray[2], startArray[1] - 1, startArray[0]);
    const endObj: any = new Date(endArray[2], endArray[1] - 1, endArray[0]);
    const diffTime = endObj - startObj;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays;
  },
  totalDaysBooked: (start: any, end: any, timezone: string) => {
    let totalDaysBooked = null;
    if (start && end) {
      const startDate = timezone
        ? moment(start).tz(timezone).startOf('day')
        : moment(start).startOf('day');
      const endDate = timezone ? moment(end).tz(timezone).endOf('day') : moment(end).endOf('day');
      const noOfDays = endDate.diff(startDate, 'days');
      totalDaysBooked = noOfDays + ' days';
    }
    return totalDaysBooked;
  },
  convertDurationStringToHours: (duration: string) => {
    const minutes = parseInt(duration.replace(' mins', ''), 10);

    if (isNaN(minutes) || minutes < 0) {
      return 'Invalid duration';
    }

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0) {
      return `${hours} hrs ${remainingMinutes} mins`;
    } else {
      return `${remainingMinutes} mins`;
    }
  },
  scrollToTop: () => {
    const elem = document.getElementsByClassName('container-bg ')[0];
    if (elem) elem.scrollTop = 0;
    window.scrollTo({ top: 0 });
  },
  scrollElementToView: (
    className: string,
    scrollLogicalPosition: ScrollLogicalPosition = 'center'
  ) => {
    const elem = document.getElementsByClassName(className)[0];
    if (elem) elem.scrollIntoView({ behavior: 'smooth', block: scrollLogicalPosition });
  },
  scrollToField: (id: string) => {
    const element = document.getElementById(id) as HTMLElement;
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  },
  getPetTypes: (petTypes?: string[]) => {
    if (petTypes && petTypes?.length === 1) {
      return petTypes[0].toLowerCase() === 'cat' ? 'cat' : 'dog';
    } else {
      return '';
    }
  },
  formatAmount: (amount?: string | number) => {
    return formatValue({
      value: '' + Number(amount ? amount : 0).toFixed(2),
      groupSeparator: ',',
      decimalSeparator: '.',
      prefix: '',
    });
  },
  parseMMDDYYYY: (dateStr: string): DayValue => {
    if (!dateStr) return null;

    const [monthStr, dayStr, yearStr] = dateStr.split('/');
    const month = parseInt(monthStr, 10);
    const day = parseInt(dayStr, 10);
    const year = parseInt(yearStr, 10);

    if (isNaN(month) || isNaN(day) || isNaN(year)) return null;

    return { year, month, day };
  },
  getFileSize: (fileSize: string, decimals = 2) => {
    const bytes = fileSize ? parseInt(fileSize) : 0;
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  },
  formatSlotDate: (date: string, tz?: string) => {
    if (tz) {
      return moment(date).tz(tz).format('hh:mm A');
    } else {
      return moment(date).format('hh:mm A');
    }
  },
  isMobile: () => {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },
  isValidPhoneNumber: (phoneNumber: string, countryData?: any): { isValid: boolean; message?: string } => {


    console.log("countryData", countryData);

    if (!phoneNumber || phoneNumber.trim().length < 2) {
      return { isValid: false, message: 'Please enter a valid phone number' };
    }

    if (!countryData) {
      return { isValid: false, message: 'Please select a country' };
    }

    // Extract all digits from the phone number (including dialCode)
    const digitsOnly = phoneNumber.replace(/\D/g, "");

    // Extract total required digits from country.format (all dots represent digits)
    const totalDotsInFormat = (countryData.format.match(/\./g) || []).length;

    // Calculate national number digits (excluding country code)
    const dialCodeLength = countryData.dialCode.length;
    const nationalDigitsRequired = totalDotsInFormat - dialCodeLength;

    // Check if country is in allowed list for strict validation
    const isAllowedCountry = ALLOWED_PHONE_COUNTRIES.includes(countryData.countryCode.toLowerCase());

    if (isAllowedCountry) {
      // For allowed countries, validate exact digit count
      if (digitsOnly.length !== totalDotsInFormat) {
        return {
          isValid: false,
          message: `Phone number must be ${nationalDigitsRequired} digits for ${countryData.name}`
        };
      }
    } else {
      // For other countries, just check minimum 7 digits
      if (digitsOnly.length - countryData.dialCode.length < 7) {
        return {
          isValid: false,
          message: `Phone number must be at least 7 digits for ${countryData.name}`
        };
      }
    }

    return {
      isValid: true,
      message: `Valid phone number (${digitsOnly.length} digits)`
    };
  },
};

export default Utils;